const serverUrl = 'https://api.specietor.csw.cl';
const webUrl = 'https://specietor.csw.cl';

export default {
  webUrl,
  serverUrl,
};
